import { InvoiceShow } from '../../billing-center';

export interface IAPIAddInvoiceBody {
  readonly studioID: string;
  readonly data: ReadonlyArray<IAPIFeeCenterMailManageItem>;
}

export interface IAPIFeeCenterMailManageItem {
  readonly createTime: string;
  readonly updateTime?: string;
  readonly email: string;
  readonly isDefault: boolean;
  readonly studioID: string;
}

export enum InvoiceTarget {
  Enterprise = 1,
}

export enum InvoiceType {
  Common = 2,
  Special = 3,
}

export interface IAPIInvoiceHeader {
  invoice_id: string;
  studio_id: string;
  invoice_target: InvoiceTarget;
  invoice_type: InvoiceType;
  invoice_name: string;
  identification_code: string;
  open_bank: string;
  open_account: string;
  enterprise_address: string;
  enterprise_phone: string;
  create_time: string;
  update_time: string;
}

export interface IAPICreateUpdateInvoiceInfo {
  invoice_id?: string;
  studio_id: string;
  invoice_target: InvoiceTarget;
  invoice_type: InvoiceType;
  invoice_name: string;
  identification_code: string;
  open_bank: string;
  open_account: string;
  enterprise_address: string;
  enterprise_phone: string;
}

export interface IAPICanOpenInvoiceBillItem {
  amount: string;
  balance: string;
  consume_creator: string;
  consume_id: string;
  consume_type: number;
  create_time: string;
  game_id: number;
  service_id: number;
  studio_id: number;
  tax_rate: string;
  update_time?: string;
  ['invoice_order.amount']: string;
}

export interface IAPIApplyInvoiceItem {
  invoice_id: string; // 抬头id
  studio_id: string;
  consume_ids: string;

  currency_code: string;
  invoice_month: string;
  mdm_id: string;
  mdm_name: string;
  email: string;
  unit: string;
  make_out_item: string;
  specification: string;
  remark: string;
  show_buyer: InvoiceShow;
  show_seller: InvoiceShow;
}

export enum InvoiceStatus {
  Applying = 1,
  Opening = 2,
  Fail = 3,
  Success = 5,
}

export interface IAPIInvoiceHistoryItem {
  invoice_order_id: string;
  studio_id: string;
  consume_id: string;
  invoice_status: InvoiceStatus;
  message: string;
  invoice_mode: number;
  invoice_type: InvoiceType;
  ims_apply_id: string;
  invoice_id_ims: string;
  invoice_no: string;
  invoice_code: string;
  make_out_item: string;
  amount: string;
  no_tax_amount: string;
  tax_amount: string;
  currency_code: string;
  file_id: string;
  file_url: string;
  apply_id: string;
  create_time: string;
}
